// generated file
// generated file
// generated file

import "primeflex/primeflex.min.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";

import * as React from "react";

export interface ThemeProviderProps {
  theme: string;
  replaceColors: boolean;
  children?: any;
}

const getThemeProvider = ({ theme, replaceColors }: ThemeProviderProps) => {
  if (replaceColors && theme === "arya-blue") {
    return React.lazy(() => import("./arya-blue/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "arya-green") {
    return React.lazy(() => import("./arya-green/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "arya-orange") {
    return React.lazy(() => import("./arya-orange/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "arya-purple") {
    return React.lazy(() => import("./arya-purple/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "bootstrap4-dark-blue") {
    return React.lazy(
      () => import("./bootstrap4-dark-blue/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "bootstrap4-dark-purple") {
    return React.lazy(
      () => import("./bootstrap4-dark-purple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "bootstrap4-light-blue") {
    return React.lazy(
      () => import("./bootstrap4-light-blue/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "bootstrap4-light-purple") {
    return React.lazy(
      () => import("./bootstrap4-light-purple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "fluent-light") {
    return React.lazy(() => import("./fluent-light/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "lara-dark-blue") {
    return React.lazy(() => import("./lara-dark-blue/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "lara-dark-indigo") {
    return React.lazy(
      () => import("./lara-dark-indigo/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "lara-dark-purple") {
    return React.lazy(
      () => import("./lara-dark-purple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "lara-dark-teal") {
    return React.lazy(() => import("./lara-dark-teal/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "lara-light-blue") {
    return React.lazy(
      () => import("./lara-light-blue/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "lara-light-indigo") {
    return React.lazy(
      () => import("./lara-light-indigo/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "lara-light-purple") {
    return React.lazy(
      () => import("./lara-light-purple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "lara-light-teal") {
    return React.lazy(
      () => import("./lara-light-teal/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "luna-amber") {
    return React.lazy(() => import("./luna-amber/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "luna-blue") {
    return React.lazy(() => import("./luna-blue/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "luna-green") {
    return React.lazy(() => import("./luna-green/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "luna-pink") {
    return React.lazy(() => import("./luna-pink/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "md-dark-deeppurple") {
    return React.lazy(
      () => import("./md-dark-deeppurple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "md-dark-indigo") {
    return React.lazy(() => import("./md-dark-indigo/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "md-light-deeppurple") {
    return React.lazy(
      () => import("./md-light-deeppurple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "md-light-indigo") {
    return React.lazy(
      () => import("./md-light-indigo/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "mdc-dark-deeppurple") {
    return React.lazy(
      () => import("./mdc-dark-deeppurple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "mdc-dark-indigo") {
    return React.lazy(
      () => import("./mdc-dark-indigo/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "mdc-light-deeppurple") {
    return React.lazy(
      () => import("./mdc-light-deeppurple/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "mdc-light-indigo") {
    return React.lazy(
      () => import("./mdc-light-indigo/themeWithColorsReplaced")
    );
  }

  if (replaceColors && theme === "nova") {
    return React.lazy(() => import("./nova/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "nova-accent") {
    return React.lazy(() => import("./nova-accent/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "nova-alt") {
    return React.lazy(() => import("./nova-alt/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "rhea") {
    return React.lazy(() => import("./rhea/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "saga-blue") {
    return React.lazy(() => import("./saga-blue/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "saga-green") {
    return React.lazy(() => import("./saga-green/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "saga-orange") {
    return React.lazy(() => import("./saga-orange/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "saga-purple") {
    return React.lazy(() => import("./saga-purple/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "tailwind-light") {
    return React.lazy(() => import("./tailwind-light/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "vela-blue") {
    return React.lazy(() => import("./vela-blue/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "vela-green") {
    return React.lazy(() => import("./vela-green/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "vela-orange") {
    return React.lazy(() => import("./vela-orange/themeWithColorsReplaced"));
  }

  if (replaceColors && theme === "vela-purple") {
    return React.lazy(() => import("./vela-purple/themeWithColorsReplaced"));
  }

  if (theme === "arya-blue") {
    return React.lazy(() => import("./arya-blue/theme"));
  }

  if (theme === "arya-green") {
    return React.lazy(() => import("./arya-green/theme"));
  }

  if (theme === "arya-orange") {
    return React.lazy(() => import("./arya-orange/theme"));
  }

  if (theme === "arya-purple") {
    return React.lazy(() => import("./arya-purple/theme"));
  }

  if (theme === "bootstrap4-dark-blue") {
    return React.lazy(() => import("./bootstrap4-dark-blue/theme"));
  }

  if (theme === "bootstrap4-dark-purple") {
    return React.lazy(() => import("./bootstrap4-dark-purple/theme"));
  }

  if (theme === "bootstrap4-light-blue") {
    return React.lazy(() => import("./bootstrap4-light-blue/theme"));
  }

  if (theme === "bootstrap4-light-purple") {
    return React.lazy(() => import("./bootstrap4-light-purple/theme"));
  }

  if (theme === "fluent-light") {
    return React.lazy(() => import("./fluent-light/theme"));
  }

  if (theme === "lara-dark-blue") {
    return React.lazy(() => import("./lara-dark-blue/theme"));
  }

  if (theme === "lara-dark-indigo") {
    return React.lazy(() => import("./lara-dark-indigo/theme"));
  }

  if (theme === "lara-dark-purple") {
    return React.lazy(() => import("./lara-dark-purple/theme"));
  }

  if (theme === "lara-dark-teal") {
    return React.lazy(() => import("./lara-dark-teal/theme"));
  }

  if (theme === "lara-light-blue") {
    return React.lazy(() => import("./lara-light-blue/theme"));
  }

  if (theme === "lara-light-indigo") {
    return React.lazy(() => import("./lara-light-indigo/theme"));
  }

  if (theme === "lara-light-purple") {
    return React.lazy(() => import("./lara-light-purple/theme"));
  }

  if (theme === "lara-light-teal") {
    return React.lazy(() => import("./lara-light-teal/theme"));
  }

  if (theme === "luna-amber") {
    return React.lazy(() => import("./luna-amber/theme"));
  }

  if (theme === "luna-blue") {
    return React.lazy(() => import("./luna-blue/theme"));
  }

  if (theme === "luna-green") {
    return React.lazy(() => import("./luna-green/theme"));
  }

  if (theme === "luna-pink") {
    return React.lazy(() => import("./luna-pink/theme"));
  }

  if (theme === "md-dark-deeppurple") {
    return React.lazy(() => import("./md-dark-deeppurple/theme"));
  }

  if (theme === "md-dark-indigo") {
    return React.lazy(() => import("./md-dark-indigo/theme"));
  }

  if (theme === "md-light-deeppurple") {
    return React.lazy(() => import("./md-light-deeppurple/theme"));
  }

  if (theme === "md-light-indigo") {
    return React.lazy(() => import("./md-light-indigo/theme"));
  }

  if (theme === "mdc-dark-deeppurple") {
    return React.lazy(() => import("./mdc-dark-deeppurple/theme"));
  }

  if (theme === "mdc-dark-indigo") {
    return React.lazy(() => import("./mdc-dark-indigo/theme"));
  }

  if (theme === "mdc-light-deeppurple") {
    return React.lazy(() => import("./mdc-light-deeppurple/theme"));
  }

  if (theme === "mdc-light-indigo") {
    return React.lazy(() => import("./mdc-light-indigo/theme"));
  }

  if (theme === "nova") {
    return React.lazy(() => import("./nova/theme"));
  }

  if (theme === "nova-accent") {
    return React.lazy(() => import("./nova-accent/theme"));
  }

  if (theme === "nova-alt") {
    return React.lazy(() => import("./nova-alt/theme"));
  }

  if (theme === "rhea") {
    return React.lazy(() => import("./rhea/theme"));
  }

  if (theme === "saga-blue") {
    return React.lazy(() => import("./saga-blue/theme"));
  }

  if (theme === "saga-green") {
    return React.lazy(() => import("./saga-green/theme"));
  }

  if (theme === "saga-orange") {
    return React.lazy(() => import("./saga-orange/theme"));
  }

  if (theme === "saga-purple") {
    return React.lazy(() => import("./saga-purple/theme"));
  }

  if (theme === "tailwind-light") {
    return React.lazy(() => import("./tailwind-light/theme"));
  }

  if (theme === "vela-blue") {
    return React.lazy(() => import("./vela-blue/theme"));
  }

  if (theme === "vela-green") {
    return React.lazy(() => import("./vela-green/theme"));
  }

  if (theme === "vela-orange") {
    return React.lazy(() => import("./vela-orange/theme"));
  }

  if (theme === "vela-purple") {
    return React.lazy(() => import("./vela-purple/theme"));
  }

  return React.lazy(() => import("./saga-green/theme"));
};

export const ThemeProvider = ({
  theme,
  replaceColors,
  children,
}: ThemeProviderProps) => {
  const _ThemeProvider = React.useMemo(
    () => getThemeProvider({ theme, replaceColors }),
    [theme, replaceColors]
  );

  return <_ThemeProvider>{children}</_ThemeProvider>;
};

export const getThemeList = () => {
  return [
    {
      themeName: "arya-blue",
      path: "primereact/resources/themes/arya-blue/theme.css",
    },

    {
      themeName: "arya-green",
      path: "primereact/resources/themes/arya-green/theme.css",
    },

    {
      themeName: "arya-orange",
      path: "primereact/resources/themes/arya-orange/theme.css",
    },

    {
      themeName: "arya-purple",
      path: "primereact/resources/themes/arya-purple/theme.css",
    },

    {
      themeName: "bootstrap4-dark-blue",
      path: "primereact/resources/themes/bootstrap4-dark-blue/theme.css",
    },

    {
      themeName: "bootstrap4-dark-purple",
      path: "primereact/resources/themes/bootstrap4-dark-purple/theme.css",
    },

    {
      themeName: "bootstrap4-light-blue",
      path: "primereact/resources/themes/bootstrap4-light-blue/theme.css",
    },

    {
      themeName: "bootstrap4-light-purple",
      path: "primereact/resources/themes/bootstrap4-light-purple/theme.css",
    },

    {
      themeName: "fluent-light",
      path: "primereact/resources/themes/fluent-light/theme.css",
    },

    {
      themeName: "lara-dark-blue",
      path: "primereact/resources/themes/lara-dark-blue/theme.css",
    },

    {
      themeName: "lara-dark-indigo",
      path: "primereact/resources/themes/lara-dark-indigo/theme.css",
    },

    {
      themeName: "lara-dark-purple",
      path: "primereact/resources/themes/lara-dark-purple/theme.css",
    },

    {
      themeName: "lara-dark-teal",
      path: "primereact/resources/themes/lara-dark-teal/theme.css",
    },

    {
      themeName: "lara-light-blue",
      path: "primereact/resources/themes/lara-light-blue/theme.css",
    },

    {
      themeName: "lara-light-indigo",
      path: "primereact/resources/themes/lara-light-indigo/theme.css",
    },

    {
      themeName: "lara-light-purple",
      path: "primereact/resources/themes/lara-light-purple/theme.css",
    },

    {
      themeName: "lara-light-teal",
      path: "primereact/resources/themes/lara-light-teal/theme.css",
    },

    {
      themeName: "luna-amber",
      path: "primereact/resources/themes/luna-amber/theme.css",
    },

    {
      themeName: "luna-blue",
      path: "primereact/resources/themes/luna-blue/theme.css",
    },

    {
      themeName: "luna-green",
      path: "primereact/resources/themes/luna-green/theme.css",
    },

    {
      themeName: "luna-pink",
      path: "primereact/resources/themes/luna-pink/theme.css",
    },

    {
      themeName: "md-dark-deeppurple",
      path: "primereact/resources/themes/md-dark-deeppurple/theme.css",
    },

    {
      themeName: "md-dark-indigo",
      path: "primereact/resources/themes/md-dark-indigo/theme.css",
    },

    {
      themeName: "md-light-deeppurple",
      path: "primereact/resources/themes/md-light-deeppurple/theme.css",
    },

    {
      themeName: "md-light-indigo",
      path: "primereact/resources/themes/md-light-indigo/theme.css",
    },

    {
      themeName: "mdc-dark-deeppurple",
      path: "primereact/resources/themes/mdc-dark-deeppurple/theme.css",
    },

    {
      themeName: "mdc-dark-indigo",
      path: "primereact/resources/themes/mdc-dark-indigo/theme.css",
    },

    {
      themeName: "mdc-light-deeppurple",
      path: "primereact/resources/themes/mdc-light-deeppurple/theme.css",
    },

    {
      themeName: "mdc-light-indigo",
      path: "primereact/resources/themes/mdc-light-indigo/theme.css",
    },

    {
      themeName: "nova",
      path: "primereact/resources/themes/nova/theme.css",
    },

    {
      themeName: "nova-accent",
      path: "primereact/resources/themes/nova-accent/theme.css",
    },

    {
      themeName: "nova-alt",
      path: "primereact/resources/themes/nova-alt/theme.css",
    },

    {
      themeName: "rhea",
      path: "primereact/resources/themes/rhea/theme.css",
    },

    {
      themeName: "saga-blue",
      path: "primereact/resources/themes/saga-blue/theme.css",
    },

    {
      themeName: "saga-green",
      path: "primereact/resources/themes/saga-green/theme.css",
    },

    {
      themeName: "saga-orange",
      path: "primereact/resources/themes/saga-orange/theme.css",
    },

    {
      themeName: "saga-purple",
      path: "primereact/resources/themes/saga-purple/theme.css",
    },

    {
      themeName: "tailwind-light",
      path: "primereact/resources/themes/tailwind-light/theme.css",
    },

    {
      themeName: "vela-blue",
      path: "primereact/resources/themes/vela-blue/theme.css",
    },

    {
      themeName: "vela-green",
      path: "primereact/resources/themes/vela-green/theme.css",
    },

    {
      themeName: "vela-orange",
      path: "primereact/resources/themes/vela-orange/theme.css",
    },

    {
      themeName: "vela-purple",
      path: "primereact/resources/themes/vela-purple/theme.css",
    },
  ];
};

export interface ThemeVariablesListEntry {
  themeName: string;
  getModule: () => Promise<any>;
}
export const getThemeVariables = (): ThemeVariablesListEntry[] => {
  return [
    {
      themeName: "arya-blue",
      getModule: () => import("./arya-blue/theme-variables"),
    },

    {
      themeName: "arya-green",
      getModule: () => import("./arya-green/theme-variables"),
    },

    {
      themeName: "arya-orange",
      getModule: () => import("./arya-orange/theme-variables"),
    },

    {
      themeName: "arya-purple",
      getModule: () => import("./arya-purple/theme-variables"),
    },

    {
      themeName: "bootstrap4-dark-blue",
      getModule: () => import("./bootstrap4-dark-blue/theme-variables"),
    },

    {
      themeName: "bootstrap4-dark-purple",
      getModule: () => import("./bootstrap4-dark-purple/theme-variables"),
    },

    {
      themeName: "bootstrap4-light-blue",
      getModule: () => import("./bootstrap4-light-blue/theme-variables"),
    },

    {
      themeName: "bootstrap4-light-purple",
      getModule: () => import("./bootstrap4-light-purple/theme-variables"),
    },

    {
      themeName: "fluent-light",
      getModule: () => import("./fluent-light/theme-variables"),
    },

    {
      themeName: "lara-dark-blue",
      getModule: () => import("./lara-dark-blue/theme-variables"),
    },

    {
      themeName: "lara-dark-indigo",
      getModule: () => import("./lara-dark-indigo/theme-variables"),
    },

    {
      themeName: "lara-dark-purple",
      getModule: () => import("./lara-dark-purple/theme-variables"),
    },

    {
      themeName: "lara-dark-teal",
      getModule: () => import("./lara-dark-teal/theme-variables"),
    },

    {
      themeName: "lara-light-blue",
      getModule: () => import("./lara-light-blue/theme-variables"),
    },

    {
      themeName: "lara-light-indigo",
      getModule: () => import("./lara-light-indigo/theme-variables"),
    },

    {
      themeName: "lara-light-purple",
      getModule: () => import("./lara-light-purple/theme-variables"),
    },

    {
      themeName: "lara-light-teal",
      getModule: () => import("./lara-light-teal/theme-variables"),
    },

    {
      themeName: "luna-amber",
      getModule: () => import("./luna-amber/theme-variables"),
    },

    {
      themeName: "luna-blue",
      getModule: () => import("./luna-blue/theme-variables"),
    },

    {
      themeName: "luna-green",
      getModule: () => import("./luna-green/theme-variables"),
    },

    {
      themeName: "luna-pink",
      getModule: () => import("./luna-pink/theme-variables"),
    },

    {
      themeName: "md-dark-deeppurple",
      getModule: () => import("./md-dark-deeppurple/theme-variables"),
    },

    {
      themeName: "md-dark-indigo",
      getModule: () => import("./md-dark-indigo/theme-variables"),
    },

    {
      themeName: "md-light-deeppurple",
      getModule: () => import("./md-light-deeppurple/theme-variables"),
    },

    {
      themeName: "md-light-indigo",
      getModule: () => import("./md-light-indigo/theme-variables"),
    },

    {
      themeName: "mdc-dark-deeppurple",
      getModule: () => import("./mdc-dark-deeppurple/theme-variables"),
    },

    {
      themeName: "mdc-dark-indigo",
      getModule: () => import("./mdc-dark-indigo/theme-variables"),
    },

    {
      themeName: "mdc-light-deeppurple",
      getModule: () => import("./mdc-light-deeppurple/theme-variables"),
    },

    {
      themeName: "mdc-light-indigo",
      getModule: () => import("./mdc-light-indigo/theme-variables"),
    },

    {
      themeName: "nova",
      getModule: () => import("./nova/theme-variables"),
    },

    {
      themeName: "nova-accent",
      getModule: () => import("./nova-accent/theme-variables"),
    },

    {
      themeName: "nova-alt",
      getModule: () => import("./nova-alt/theme-variables"),
    },

    {
      themeName: "rhea",
      getModule: () => import("./rhea/theme-variables"),
    },

    {
      themeName: "saga-blue",
      getModule: () => import("./saga-blue/theme-variables"),
    },

    {
      themeName: "saga-green",
      getModule: () => import("./saga-green/theme-variables"),
    },

    {
      themeName: "saga-orange",
      getModule: () => import("./saga-orange/theme-variables"),
    },

    {
      themeName: "saga-purple",
      getModule: () => import("./saga-purple/theme-variables"),
    },

    {
      themeName: "tailwind-light",
      getModule: () => import("./tailwind-light/theme-variables"),
    },

    {
      themeName: "vela-blue",
      getModule: () => import("./vela-blue/theme-variables"),
    },

    {
      themeName: "vela-green",
      getModule: () => import("./vela-green/theme-variables"),
    },

    {
      themeName: "vela-orange",
      getModule: () => import("./vela-orange/theme-variables"),
    },

    {
      themeName: "vela-purple",
      getModule: () => import("./vela-purple/theme-variables"),
    },
  ];
};
